import { Stack, Typography } from "@mui/material";
import React from "react";
import { priorityComparer } from "@entrilia/shared/utilities/arrayHelper";
import type { InvestorChangeRequestDetails } from "../../../../api/types/workflowTypes";
import AssignedEntitiesSection from "./AssignedEntitiesSection";
import ChangeRequestComment from "./ChangeRequestComment";
import ChangeRequestDiffsSection from "./ChangeRequestDiffsSection";

interface Props {
  changeRequestDetails: InvestorChangeRequestDetails;
}

const InvestorChangeRequestDetailsSection = ({ changeRequestDetails }: Props) => {
  const sortedChangeSets = [...changeRequestDetails.changeSets].sort(
    priorityComparer((i) => i.changeSetType === "BankAccount")
  );

  return (
    <Stack spacing={3}>
      <Typography variant="subtitle1">Request Details</Typography>

      {changeRequestDetails.comment && <ChangeRequestComment comment={changeRequestDetails.comment} />}

      {sortedChangeSets.map((changeSet) => (
        <React.Fragment key={changeSet.changeSetType}>
          <ChangeRequestDiffsSection changeSet={changeSet} workflowStatus={changeRequestDetails.workflowStatus} />

          {changeSet.assignedEntityChanges && changeSet.assignedEntityChanges.length > 0 && (
            <AssignedEntitiesSection assignedEntityChanges={changeSet.assignedEntityChanges} />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default InvestorChangeRequestDetailsSection;
